export default "__VITE_ASSET__DvULFdpY__"